export default "__VITE_ASSET__Dg0H56CU__"